import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Overall from './Overall';
import Streaming from './Streaming';
import Download from './Download';

import { performanceSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { EntityContext } from 'context/entityContext';
import Playlist from './Playlist';

const Performance: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix, artistMetadata } = props;
  const { entities } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="performance" variants={performanceSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/project/${entities}/performance/all`}
        render={(): ReactNode => <Overall />}
      />
      <Route
        exact
        path={`${pathPrefix}/project/${entities}/performance/streaming`}
        render={(): ReactNode => <Streaming />}
      />
      <Route
        exact
        path={`${pathPrefix}/project/${entities}/performance/download`}
        render={(): ReactNode => <Download />}
      />
      <Route
        exact
        path={`${pathPrefix}/project/${entities}/performance/playlist`}
        render={(): ReactNode => (
          <Playlist
            artist={{
              entityType: artistMetadata?.type,
              entityId: artistMetadata?.id,
            }}
            topic="overview/view"
          />
        )}
      />
    </>
  );
};

export default Performance;
